<template>
  <router-view v-slot="{ Component, route: slotRoute }">
    <template v-if="shouldRender(slotRoute)">
      <keep-alive v-if="keepAlive" :include="include" :max="max">
        <component :is="Component"/>
      </keep-alive>
      <component v-else :is="Component"/>
    </template>
    <!-- CLIENT-ONLY -->
  </router-view>
</template>

<script setup lang="ts">
import { inject, provide } from 'vue';
import { RouteLocationNormalizedLoaded } from 'vue-router';
import { ROUTER_VIEW_DEPTH_KEY } from './clientOnlyRouterViewSymbols';

interface Props {
  keepAlive?: boolean;
  include?: string | string[] | RegExp;
  max?: number | string;
}

const props = withDefaults(defineProps<Props>(), {
  keepAlive: false,
  max: 5
});

/**
 * Получаем depth родительского ClientOnlyRouterView
 * parentDepth = depth компонента в котором находится этот ClientOnlyRouterView
 */
const parentDepth = inject<number>(ROUTER_VIEW_DEPTH_KEY, -1);

/**
 * currentDepth = depth этого ClientOnlyRouterView (где он находится)
 */
const currentDepth = parentDepth + 1;

/**
 * childDepth = depth компонента который этот ClientOnlyRouterView будет рендерить
 */
const childDepth = currentDepth + 1;

/**
 * Предоставляем currentDepth для дочерних компонентов
 */
provide(ROUTER_VIEW_DEPTH_KEY, currentDepth);

/**
 * Проверяет, должен ли компонент рендериться на текущем уровне вложенности
 */
const shouldRender = (slotRoute: RouteLocationNormalizedLoaded): boolean => {
  // На клиенте всегда рендерим
  if (!process.env.SERVER) {
    return true;
  }

  // На сервере проверяем meta.clientOnly для дочернего компонента
  const matchedRoute = slotRoute.matched[childDepth];

  if (!matchedRoute) {
    return true;
  }

  // Если clientOnly === true, то НЕ рендерим на сервере
  return matchedRoute.meta?.clientOnly !== true;
};
</script>

